import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { local_routes } from "utils/Routes";
import axios from "axios";
import { Button } from "react-bootstrap";
import { apiUrl } from "Api/Api";
import { assembleNickname } from "utils/Helper";
import moment from "moment";

const PechaKuchaChannelsLocationsTableRow = (props) => {
  const [selected_access_level_option, setSelectedAccessLevelOption] =
    useState();
  const [createdTime, setCreatedTime] = useState();
  // console.log("ROW PROPS:", props);

  let workspace_base_url = "";
  if (props.workspace_base_url) {
    workspace_base_url = props.workspace_base_url;
  }

  useEffect(() => {
    if (!selected_access_level_option) {
      setSelectedAccessLevelOption(props.data.access_level_option);
      displayPrettyDate(props.data.created_time);
    }
  }, []);

  const displayPrettyDate = (timeData) => {
    let prettyDate = moment.unix(timeData).format("MM/DD/YYYY");
    return setCreatedTime(prettyDate);
  };

  return (
    <tr>
      <td style={{ fontSize: "smaller" }}>
        {props.data.entity_name || assembleNickname(props.data)}
      </td>
      <td style={{ fontSize: "smaller" }}>
        <NavLink
          target="_blank"
          to={`${workspace_base_url}${local_routes[props.data.entity_type]}/${
            props.data.friendly_url
          }`}
        >
          {props.data.friendly_url}
        </NavLink>
      </td>
      <td>{createdTime}</td>
      <td style={{ fontSize: "smaller" }}>
        <Button onClick={() => props.handleShow(props.data)}>
          Edit {props.data.entity_type === "channels" ? "Channel" : "City"}
        </Button>
      </td>
    </tr>
  );
};

export default PechaKuchaChannelsLocationsTableRow;
